import useContinueHpDeviceDraft, {
    IUseContinueHpDeviceDraftOutput,
} from "./useContinueHpDeviceDraft"
import { LCTOnlyDatasets } from "../../../../../constants/enums"

/**
 * Thin wrapper around useContinueHpDeviceDraft — the only difference is the
 * dataset passed to the API (ACU vs HP). All form data, types, and mappers are
 * shared.
 */
const useContinueAcuDeviceDraft = (
    deviceRef: string
): IUseContinueHpDeviceDraftOutput =>
    useContinueHpDeviceDraft(deviceRef, LCTOnlyDatasets.ACU)

export default useContinueAcuDeviceDraft
